export function isExternalUrl(url: string) {
  return url ? !(url.startsWith('/') && !url.startsWith('//')) : false;
}
